import { SpaceplanTabType } from './spaceplan';

export const spaceplanTabSelectOptions = [
  {
    disabled: false,
    title: 'Audio',
    value: SpaceplanTabType.AUDIO,
  },
  {
    disabled: false,
    title: 'Control',
    value: SpaceplanTabType.CONTROL,
  },
  {
    disabled: false,
    title: 'Network',
    value: SpaceplanTabType.NETWORK,
  },
  {
    disabled: false,
    title: 'Video',
    value: SpaceplanTabType.VIDEO,
  },
];
